import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from 'components/App';
import store from 'store/store';
import GlobalStyle from 'common/global.styled';
import AnimationStyle from 'common/animation.styled';
import 'index.css';

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>
    <GlobalStyle />
    <AnimationStyle />
  </React.StrictMode>,
  document.getElementById('root')
);
